import { httpRequest } from "../../http";
import type { AddCorrectionPayload, Correction } from "@models/Discrepancy.model";

export class CommandAddCorrection {
  async run(discrepancyId: number, payload: AddCorrectionPayload): Promise<Correction> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/discrepancies/${discrepancyId}/corrections/`;
    return httpRequest<Correction, AddCorrectionPayload>(url, { method: "POST", body: payload });
  }
}
